import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    circle: PropTypes.object.isRequired,
  },
  getInitialState() {
    return {
      circle: this.props.circle,
    };
  },
  onError() {
    var updated = this.state.circle;
    updated.main_image_url = "/images/ja2/img_noimage.gif";
    this.setState({
      circle: updated,
    });
  },
  render() {
    var circle = this.state.circle;
    return (
      <div className="touch-box" style={{ width: "200px" }}>
        <article className="circle-box" style={{ height: "100%" }}>
          <a className="timeline_circle-link" href={`/circle/${circle.id}`}>
            <div className="timeline_circle-image">
              <img
                src={circle.main_image_url}
                alt={circle.name}
                onError={this.onError}
              />
              {/* <div className="type">注目</div> */}
            </div>
            <div className="timeline_circle-description">
              <h3
                className="line-2 font-size-14"
                style={{ height: "38px", lineHeight: "1.5" }}
              >
                {circle.about}
              </h3>
              <h4 className="line-1 font-size-10">{circle.name}</h4>
              <p className="font-size-10 color-main-strong">
                {circle.countries_pref ? circle.countries_pref.name : ""}
              </p>
            </div>
          </a>
        </article>
      </div>
    );
  },
});
